import { render, staticRenderFns } from "./TabelaRupturas.vue?vue&type=template&id=552311b3&scoped=true"
import script from "./TabelaRupturas.vue?vue&type=script&lang=js"
export * from "./TabelaRupturas.vue?vue&type=script&lang=js"
import style0 from "./TabelaRupturas.vue?vue&type=style&index=0&id=552311b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552311b3",
  null
  
)

export default component.exports